module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portfolio",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header', {
    style: ({
      height: _vm.isMobi ? (_vm.currentPage === 1 && _vm.currentCat !== 0 && _vm.currentCat <= 40 ? '180px' : '50px') : '1.5rem',
      backgroundColor: _vm.currentPage !== 1 ? 'transparent' : '#fff'
    })
  }, [(_vm.currentPage !== 0) ? _c('div', {
    staticClass: "sub_nav"
  }, [_c('ul', [_c('li', {
    staticClass: "pc",
    class: {
      selected: _vm.currentPage === 1 && _vm.currentCat === 0
    },
    on: {
      "click": function($event) {
        _vm.setCat(0);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].all))]), _c('li', {
    class: {
      selected: _vm.currentPage === 1 && _vm.currentCat !== 0 && _vm.currentCat <= 40
    },
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("BAI")]), _c('li', {
    class: {
      selected: _vm.currentCat === 42
    },
    on: {
      "click": function($event) {
        _vm.setCat(42);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("FOF")])])]) : _vm._e(), ((_vm.currentPage === 1) && _vm.currentCat !== 0 && _vm.currentCat <= 40) ? _c('div', {
    staticClass: "detail_nav"
  }, [_c('ul', [_c('li', {
    class: {
      selected: _vm.currentCat === 20
    },
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Upgrade))]), _c('li', {
    class: {
      selected: _vm.currentCat === 18
    },
    on: {
      "click": function($event) {
        _vm.setCat(18);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Finance))]), _c('li', {
    class: {
      selected: _vm.currentCat === 38
    },
    on: {
      "click": function($event) {
        _vm.setCat(38);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Global))]), _c('li', {
    class: {
      selected: _vm.currentCat === 24
    },
    on: {
      "click": function($event) {
        _vm.setCat(24);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Social))]), _c('li', {
    class: {
      selected: _vm.currentCat === 40
    },
    on: {
      "click": function($event) {
        _vm.setCat(40);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].Tech))])])]) : _vm._e()]), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "page first",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].portfolio))])]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }]
  }, [_c('li', {
    staticClass: "pc",
    on: {
      "click": function($event) {
        _vm.setCat(0);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].all))]), _c('li', {
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("BAI")]), _c('li', {
    on: {
      "click": function($event) {
        _vm.setCat(42);
        _vm.turnToA(1)
      }
    }
  }, [_vm._v("FOF")])])])], 1), _c('div', {
    staticClass: "all"
  }, [_c('transition', {
    attrs: {
      "appear": "appear",
      "name": "bottom-in"
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.setCat(20);
        _vm.turnToA(1)
      }
    }
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("BAI")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].bai))])])]), _c('transition', {
    attrs: {
      "appear": "appear",
      "name": "bottom-in"
    }
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": function($event) {
        _vm.setCat(42);
        _vm.turnToA(1)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("FOF")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].FOF))])])])], 1)]), _c('div', {
    ref: "protfolioList",
    staticClass: "page",
    style: ({
      height: _vm.height,
      overflowY: 'auto'
    }),
    on: {
      "touchend": _vm.touchend
    }
  }, [_c('div', {
    staticClass: "table",
    style: ({
      marginTop: _vm.isMobi ? (_vm.currentPage === 1) && _vm.currentCat !== 0 && _vm.currentCat <= 40 ? '180px' : '50px' : '1.66667rem'
    }),
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.wheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.wheel.apply(null, arguments)
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "appear": "appear",
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.currentCatList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setCurrent(index)
        },
        "mouseenter": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.mouseEnter(index)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.mouseLeave.apply(null, arguments)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    }), _c('transition', {
      attrs: {
        "name": "slide",
        "mode": "out-in"
      }
    }, [(_vm.currentLogo == index) ? _c('div', {
      staticClass: "desc pc"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("PORTFOLIO")]), _c('hr'), _c('p', [_vm._v(_vm._s(_vm.lang === 'zh' ? item.title : item.title_en))])]) : _vm._e()])], 1)
  }), 0)], 1)])]), _c('transition', {
    attrs: {
      "name": "up",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "detail_icon"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require('../assets/logo_about.png')
    }
  }), _c('div', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _c('div', {
    staticClass: "bg",
    on: {
      "click": function($event) {
        return _vm.openLink(_vm.list[_vm.currentIndex].link)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "logo",
    attrs: {
      "src": _vm.list[_vm.currentIndex] && _vm.list[_vm.currentIndex].logo
    }
  })]), _c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.list[_vm.currentIndex] && (_vm.lang === 'zh' ? _vm.list[_vm.currentIndex].title : _vm.list[_vm.currentIndex].title_en)))])]), _c('transition', {
    attrs: {
      "name": "bottom-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.list[_vm.currentIndex] && (_vm.lang === 'zh' ? _vm.list[_vm.currentIndex].content : _vm.list[_vm.currentIndex].content_en))
    }
  })])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf7bab66","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portfolio.vue
// module id = 518
// module chunks = 1